import { ExamCenterProctorType } from '@exam-center/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export function useExamCenterProctorListSearchParams() {
  const [{ search, proctorTypes, page, pageSize, sortOrder }, setQueryParams] = useQueryStates(
    {
      search: parseAsString.withDefault(''),
      proctorTypes: parseAsArrayOf(
        parseAsStringEnum(Object.values(ExamCenterProctorType)),
      ).withDefault([]),
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  const changeSortingOrder = (sortOrder: (typeof dataGridSortDirection)[number]) => {
    setQueryParams({ sortOrder, page: 0 });
  };

  const changeSearch = (value: string) => {
    setQueryParams({ search: value, page: 0 });
  };

  const changeProctorTypes = (proctorTypes: ExamCenterProctorType[]) => {
    setQueryParams({ proctorTypes, page: 0 });
  };

  return [
    {
      search,
      proctorTypes,
      page,
      pageSize,
      sortOrder,
    },
    {
      changePageNumber,
      changePageSize,
      changeSortingOrder,
      changeSearch,
      changeProctorTypes,
    },
  ] as const;
}
